import React from 'react';
import Button from '../../components/buttons/Button'
import { useDispatch, useSelector } from "react-redux";
import { checkImg } from '../../../utils/assets';
import { subscriptionModalReducer } from '../../redux/slice/subscriptionSlice';

// Subscription component
const SubscriptionCard = (subscription) => {
    const {ID, Name, Price, Currency, Validity, Details} = subscription.subscription
    
  const dispatch = useDispatch()
  const { isLoading, activeSubscription } = useSelector((state) => state.fetchPackages);
    
    // Check if the selected operator is MTN or OTHERS
    const selectedOperator = JSON.parse(localStorage.getItem('afri_selected_operator') || '{}');

    const isMTN = selectedOperator.username_prefix?.includes('amngh') || false;
    
    // Get the correct Plan ID based on operator and subscription type
    const getOperatorId = (subscriptionType = 'auto-renewal') => {
      if (typeof ID === 'object' && ID !== null) {
        const operatorKey = isMTN ? 'mtn' : 'other';
        const operatorId = ID[operatorKey];
        
        // Handle nested structure for auto-renewal/on-demand
        if (typeof operatorId === 'object' && operatorId !== null) {
          return operatorId[subscriptionType] || operatorId['auto-renewal'];
        }
        return operatorId;
      }
      return ID;
    };
    
    // Check if this plan has auto-renewal and on-demand options
    const hasSubscriptionTypes = () => {
      if (typeof ID === 'object' && ID !== null) {
        const operatorKey = isMTN ? 'mtn' : 'other';
        const operatorId = ID[operatorKey];
        return typeof operatorId === 'object' && operatorId !== null && 
               operatorId['auto-renewal'] && operatorId['on-demand'];
      }
      return false;
    };
    
    // Filter out data bonus details if not MTN
    const filteredDetails = isMTN 
      ? Details 
      : Details?.filter(detail => !detail.toLowerCase().includes('data bonus') && !detail.toLowerCase().includes('mb') && !detail.toLowerCase().includes('gb'));
    
    const _initPurchasePackage = () => {
    
      // If the plan has both auto-renewal and on-demand options, open modal with choice
      if (hasSubscriptionTypes()) {
        dispatch(subscriptionModalReducer({ 
          isOpen: true, 
          productId: ID, // Pass the full ID object
          productName: Name, 
          productPrice: Price, 
          currency: Currency,
          hasSubscriptionTypes: true,
          isMTN: isMTN
        }))
      } else {
        // Otherwise, proceed directly with the single plan ID
        const planId = getOperatorId();
        dispatch(subscriptionModalReducer({ 
          isOpen: true, 
          productId: planId, 
          productName: Name, 
          productPrice: Price, 
          currency: Currency,
          hasSubscriptionTypes: false
        }))
      }
    }
    
    return (
      <div className="subscription-card">
        <div className="plan-name">
          <h2 className="heading">{Name}</h2>
        </div>
        <div
          id="Plan-Price"
          className="plan-price"
        >
          <div className="price-currency">{Currency}</div>
          <div className="price">{Price}</div>
        </div>
        <div className="plan-duration">
          <p className="paragraph">{Validity}</p>
        </div>
        <div className="plan-benefits">
          {filteredDetails && filteredDetails.map((detail, index) => (
            <div key={index} className={'sb-item' + (index === filteredDetails.length - 1 ? ' margin-bottom-none' : '')}>
              <img
                src={checkImg}
                loading="lazy"
                alt="check mark"
                className="check-mark"
              />
              <p className="name-your-list">{detail}</p>
            </div>
          ))}
        </div>
        <div className='button-wrapper'>
          {/* If the user has an active subscription but it's the same pack, allow subscribing again */}
          <Button isDisabled={isLoading} action={() => {_initPurchasePackage()}} label={'Subscribe'} />
        </div>
      </div>
    );
};

export default SubscriptionCard;